/**
 * Derives the Help Center URL from the current app hostname.
 *
 * Subdomain mapping (replaces "app" segment with "help"):
 *   localhost           → http://localhost:3001
 *   app.c2vault.com     → https://help.c2vault.com
 *   app.dev.c2vault.com → https://help.dev.c2vault.com
 *
 * Falls back to https://help.c2vault.com for any unrecognised host.
 */
export function getHelpUrl(hostname: string): string {
  if (hostname === "localhost" || hostname.startsWith("localhost:")) {
    return "http://localhost:3001";
  }

  // Replace the "app" label in the subdomain with "help".
  // e.g. "app.c2vault.com"     → "help.c2vault.com"
  // e.g. "app.dev.c2vault.com" → "help.dev.c2vault.com"
  const replaced = hostname.replace(/(?:^|\.)app\./, (match) =>
    match.replace("app", "help")
  );

  if (replaced !== hostname) {
    return `https://${replaced}`;
  }

  return "https://help.c2vault.com";
}
